import { useState, useRef, useEffect } from 'react';
import { Popover } from 'antd';
import OPPop from '../components/OPPop';
import img_1 from '../assets/images/exp/1.webp';
import img_2 from '../assets/images/exp/2.webp';
import img_3 from '../assets/images/exp/3.webp';
import img_3_1 from '../assets/images/exp/3-1.webp';
import img_3_2 from '../assets/images/exp/3-2.webp';
import img_3_3 from '../assets/images/exp/3-3.webp';
import img_4 from '../assets/images/exp/4.webp';
import img_5 from '../assets/images/exp/5.webp';
import img_6 from '../assets/images/exp/6.webp';
import img_7 from '../assets/images/exp/7.webp';
import img_8 from '../assets/images/exp/8.webp';

import video_5 from '../assets/videos/5.mp4';
import video_8 from '../assets/videos/8.mp4';
import video_20 from '../assets/videos/scale83/20.mp4';
import video_65 from '../assets/videos/scale83/65.mp4';
import video_11 from '../assets/videos/scale83/11.mp4';

import '../styles/common.css'

import img_4_8 from '../assets/images/rhy/4-8.webp';
import img_4_10 from '../assets/images/rhy/4-10.webp';
import img_4_11 from '../assets/images/rhy/4-11.webp';
import img_4_13 from '../assets/images/rhy/4-13.webp';

import spc_1 from '../assets/images/spc/1.webp'
import spc_3 from '../assets/images/spc/3.webp'
import spc_4 from '../assets/images/spc/4.webp'
import spc_5 from '../assets/images/spc/5.webp'
import spc_6 from '../assets/images/spc/6.webp'
import spc_7 from '../assets/images/spc/7.webp'
import spc_8 from '../assets/images/spc/8.webp'
import spc_9 from '../assets/images/spc/9.webp'
import spc_10 from '../assets/images/spc/10.webp'
import spc_11 from '../assets/images/spc/11.webp'

// 瓷品项接口
interface PorcelainItem {
  id: number;
}
export default function Exploration() {
  const parentRef = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isImg32InView, setIsImg32InView] = useState(false); // 新增状态：跟踪img_3_2父节点是否可见
  const img32ParentRef = useRef<HTMLDivElement>(null); // 新增ref：绑定img_3_2的父容器
  // 添加状态：记录当前选中的interactive-body的唯一标识（假设用索引）
  const [selectedInteractiveId, setSelectedInteractiveId] = useState<number | null>(5);

  const [isParentInView3, setIsParentInView3] = useState(false);
  // 新增：父容器ref（假设图片的父容器是某个div，需根据实际结构调整）
  const parentRef3 = useRef<HTMLDivElement>(null);

  const [selectedItem, setSelectedItem] = useState<PorcelainItem | null>(null);

  const [isPlayVideo, setIsPlayVideo] = useState(true);

  const [videoID, setVideoID] = useState(83);
  const [videoTop, setVideoTop] = useState(0);

  const [isParentInView1, setIsParentInView1] = useState(false);
  // 新增：父容器ref（假设图片的父容器是某个div，需根据实际结构调整）
  const parentRef1 = useRef<HTMLDivElement>(null);



  // 点击interactive-body时触发
  const handleInteractiveClick = (id: number, element: HTMLElement) => {
    if (!parentRef.current) return;

    const parentRect = parentRef.current.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    // 计算相对位置百分比
    const relativeTop = ((elementRect.top - parentRect.top) / parentRect.height) * 100;
    setVideoTop(relativeTop);
    setSelectedInteractiveId(prev => {
      const isZooming = prev !== id;
      setIsPlayVideo(isZooming);
      if (isZooming) {
        setVideoID(id);
      } else {
        setVideoID(0);
      }
      return isZooming ? id : null;
    });
  };

  // 全局点击事件：点击非interactive-body区域时复原
  useEffect(() => {
    const handleGlobalClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // 检查点击目标是否是interactive-body或其内部元素
      if (!target.closest('.interactive-body') && target.closest('.interactive-base')) {
        setSelectedInteractiveId(null);
        setIsPlayVideo(false);
        setVideoID(0);
      }
    };
    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsImg32InView(true); // 父节点进入视口时触发旋转
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 } // 父节点10%可见即触发
    );

    if (img32ParentRef.current) {
      observer.observe(img32ParentRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setIsParentInView3(true); // 父节点进入视口时触发
        observer.unobserve(entry.target); // 触发后停止监听
      }
    }, {
      rootMargin: '-50px 0px', // 调整触发时机（可选）
    });

    if (parentRef3.current) {
      observer.observe(parentRef3.current); // 监听父容器
    }

    return () => {
      if (parentRef3.current) observer.unobserve(parentRef3.current);
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setIsParentInView1(true); // 父节点进入视口时触发
        observer.unobserve(entry.target); // 触发后停止监听
      }
    }, {
      rootMargin: '-50px 0px', // 调整触发时机（可选）
    });

    if (parentRef1.current) {
      observer.observe(parentRef1.current); // 监听父容器
    }

    return () => {
      if (parentRef1.current) observer.unobserve(parentRef1.current);
    };
  }, []);
  // 标题数组（原左侧标题列表）
  const interactiveTitles = [
    '彝', '盏', '方壶', '花囊', '托', '塔', '匣', '碗', '碟', '水注',
    '觚', '洗', '盒', '炉', '爵', '卣', '水丞', '', '杯', '',
    '鼎', '缾', '砚', '灯', '尊', '壶'
  ];

  // 更新后的交互项配置结构
  interface InteractiveItem {
    rowId: number;
    items: {
      id: number;
      title: string;
      subtitle: string;
      widthClass?: string;
    }[];
  }

  const interactiveItems: InteractiveItem[] = [
    {
      rowId: 1,
      items: [{ id: 1, title: '宋定窑仿古兽面雷文彝 4', subtitle: 'Ting Yao of the Sung dynasty — Ancestral Vessel with monsters‘ heads and band of scroll design 4' }]
    },
    {
      rowId: 2,
      items: [
        { id: 2, title: '明永乐窑脱胎龙凤暗花杯 62', subtitle: 'YuNG-Lo YAo of the Ming dynasty.Small Eggshell’Cup with dragons and phoenixesengraved in the paste under the glaze. 62' },
        { id: 3, title: '明宣窑积红三鱼小盏 61', subtitle: 'HsüAn Yao of the Ming dynasty.Small bowl.shaped Wine Cup deco.rated in deep red with three fish. 61' }  // 修复id=3的填充
      ]
    },
    {
      rowId: 3,
      items: [{ id: 4, title: '宋官窑兽耳方壶 17', subtitle: 'Kuan Yao of the Sung dynasty — Quadrangular Vase with ringed monster-head handles 17' }]
    },
    {
      rowId: 4,
      items: [{ id: 5, title: '宋龙泉窑多嘴花囊 25', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Flower Receptacle with several mouths 25' }]
    },
    {
      rowId: 5,
      items: [{ id: 6, title: '宋官窑雕文盏托 74', subtitle: 'KuAN YAo of the Sung dynasty. Shaped Saucerengraved with carved lacquer ornamentation. 74' }]
    },
    {
      rowId: 6,
      items: [{ id: 7, title: '明宣窑五彩舍利塼 77', subtitle: 'HsüAx YAo of the Ming dynasty. Relic Pagoda painted in five colours. 77' }]
    },
    {
      rowId: 7,
      items: [{ id: 8, title: '明宣窑青花文姬匣 69', subtitle: 'HsüAn Yao of the Ming dynasty.Sacrificial Vessel of archaic formdecorated in blue and white. 69' }]
    },
    {
      rowId: 8,
      items: [{ id: 9, title: '明宣窑积红三鱼宫碗 70', subtitle: 'HsüAn YAo of the Ming dynasty. PalaceRice Bowl decorated in deep red with three fIsh. 70' }]
    },
    {
      rowId: 9,
      items: [{ id: 10, title: '明宣窑积红龙文宫碟 73', subtitle: 'HsüAN Yao of the Ming dynasty. Palace Dishdecorated outside in deep red, with dragons engravedin the paste underneath. 73' }]
    },
    {
      rowId: 10,
      items: [{ id: 11, title: '明宣窑积红双柿水注 10', subtitle: 'Hsüan Yao of the Ming dynasty — Water Dropper in form of two persimmons 10' }]
    },
    {
      rowId: 11,
      items: [
        { id: 12, title: '宋汝窑小圆觚 22', subtitle: 'Ju Yao of the Sung dynasty — Small rounded Beaker with old bronze design 22' },
        { id: 13, title: '宋汝窑蕉叶雷文觚 19', subtitle: 'Ju Yao of the Sung dynasty — Trumpet-shaped Vase with palm-leaves and scrolled designs 19' }
      ]
    },
    {
      rowId: 12,
      items: [
        { id: 14, title: '宋东青磁菱花洗 71', subtitle: 'TuNG CH\'iNG Tz\'ǔ of the Sung dynasty.Hexagonal Bowl for washing brushes, engraved with floral scrolls. 71' },
        { id: 15, title: '明宣窑积红双鱼洗 72', subtitle: 'HsüAN YAo of the Ming dynasty. Dishfor washing brushes, decorated in deep redwith pairs of fishes. 72' }
      ]
    },
    {
      rowId: 13,
      items: [
        { id: 16, title: '明宣窑积红穿心盒 75', subtitle: 'HsüAN Yao of the Ming dynasty. RoundBox perforated through the middle, painted indeep red. 75' },
        { id: 17, title: '明成窑五彩胭脂合 76', subtitle: 'CH\'ENG Yao of the Mingdynasty. RoundBox for rouge decorated in enamel colours. 76' }
      ]
    },
    {
      rowId: 14,
      items: [
        { id: 18, title: '宋官窑冲耳乳炉5', subtitle: 'Kuan Yao of the Sung dynasty — Incense Burner with mammillated feet 5' },
        { id: 19, title: '宣窑积红朱霞映雪 6', subtitle: 'Hsüan Yao of the Ming dynasty — Antique Censer with fish-handles 6' }
      ]
    },
    {
      rowId: 15,
      items: [
        { id: 20, title: '宋官窑螭首爵 50', subtitle: 'KuAn YAo of the Sung dynasty. A SacrificialCup with dragon\'shead handle. 50' },
        { id: 21, title: '宋官窑雷文爵 53', subtitle: 'KuAN YAo of the Sung dynasty. Libation Cupdecorated with scrolled designs. 53' },
        { id: 22, title: '明正德窑素腹爵 52', subtitle: 'CHÃNG YAo of the Ming dynasty. Libation Cupof plain rounded form. 52' }
      ]
    },
    {
      rowId: 16,
      items: [
        { id: 23, title: '明弘治窑蟠虬卣 67', subtitle: 'HuNG-cHIH YAo of the Ming dynasty. WineVessel moulded in the form of two winged monsters. 67' },
        { id: 24, title: '宋龙泉窑四鹿提梁卣 68', subtitle: 'LuNG-cH\'üAN YAo of the Sung dynasty.Wine Vessel with a transverse bowed handleattached by chains engraved with four deer. 68' }
      ]
    },
    {
      rowId: 17,
      items: [
        { id: 25, title: '宋龙泉窑兽面水丞 16', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Water Pot with monster mask handles 16' },
        { id: 26, title: '宋龙泉窑高足豆水丞 12', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Water Pot of tazza shape with cover 12' },
        { id: 27, title: '宋紫定窑百摺卧蚕洗水丞 14', subtitle: 'Purple Ting Yao of the Sung dynasty — Water Pot with brushes and band of coiling silkworms 14' },
        { id: 28, title: '宋官窑蝉文水丞 13', subtitle: 'Kuan Yao of the Sung dynasty — Water Pot engraved with cicada designs 13' }
      ]
    },
    {
      rowId: 18,
      items: [
        { id: 29, title: '宋官窑佛指甲茶杯 47', subtitle: 'KuAN Yao of the Sung dynasty. TeaCup shaped like a Buddha\'s hand citron. 47' },
        { id: 30, title: '明宣窑青花龙松茶杯 48', subtitle: 'HsüAn YAo of the Ming dynasty..Set of Tea Cups decorated in blue with dragon pines. 48' },
        { id: 31, title: '明弘治窑娇黄葵花茶杯 46', subtitle: 'HuNG-cHi YAo of the Ming dynasty. Pairof Tea Cups shaped as hibiscus fowers ena.melled pale yellow. 46' },
        { id: 32, title: '明成窑紫玉兰酒杯 49', subtitle: 'Cu\'iNG YAo of the Ming dynasty. Wine Cupsimulating a crimson blossom of the Magnolia Yulan. 49' },
        { id: 33, title: '明宣窑积红霞桃形杯 56', subtitle: 'Hsijan YAo of the Ming dynasty. Tazza-shaped Cup painted in deep red with three pairs of peaches. 56' },
        { id: 34, title: '明成窑五彩蒲桃靶杯 55', subtitle: 'CH\'ENG YAo of the Ming dynasty.Tazza-shaped Cup decorated in enamel colours with grapes. 55' }
      ]
    },
    {
      rowId: 19,
      items: [
        { id: 35, title: '明宣窑积红三鱼把杯 54', subtitle: 'HsüAn Yao of the Ming dynasty.Tazza-shaped Cup decorated in deepred with three fish. 54' },
        { id: 36, title: '明宣窑积红斗笠杯 57', subtitle: 'TiNG Yao of the Sung dynasty. Cup fashioned like a plaited willow basket. 57' },
        { id: 37, title: '明宣窑积红斗笠杯 58', subtitle: 'HsüAN YAo of the Ming dynasty.Conical Wine Cup of archaic formpainted in deep red. 58' },
        { id: 38, widthClass: 'w-[20%]', title: '明成窑五彩草虫小杯 59 明成窑五彩鸡缸杯 60', subtitle: 'CH\'iNG Yao of the Ming dynasty. Pair of little Wine Cups painted in \'five colours’ with flowers and insects. 59-60' }
      ]
    },
    {
      rowId: 20,
      items: [
        { id: 39, title: '明永乐窑脱胎龙凤暗花杯 62', subtitle: 'YuNG-Lo YAo of the Ming dynasty.Small Eggshell’Cup with dragons and phoenixesengraved in the paste under the glaze. 62' },
        { id: 40, title: '明成窑五彩鹅缸杯 63', subtitle: 'CHENG Yao of the Ming dynasty. Flat-bottomed Cup painted in five colours with geese. 63' },
        { id: 41, title: '明成窑五彩菊花小杯 65', subtitle: 'CH\'ÈNG YAo of the Ming dynasty. SmallWine Cup shaped like a chrysanthemumblossom and decorated in colours. 65' },
        { id: 42, title: '明成窑五彩树根小杯 66', subtitle: 'CH\'ENG YAo of the Ming dynasty. WineCup shaped like the root of a tree painted in colours. 66' }
      ]
    },
    {
      rowId: 21,
      items: [
        { id: 43, title: '明弘治窑象篮小鼎 7', subtitle: 'Hung-chih Yao of the Ming dynasty — Small Incense Burner ‘oak basket’ 7' },
        { id: 44, title: '宋定窑仿古文王鼎 1', subtitle: 'Ting Yao of the Sung dynasty. Copy of an ancient Sacrificial Vessel of Wên Wang 1' },
        { id: 45, title: '宋官窑仿古饕餮鼎 2', subtitle: 'Kuan Yao of the Sung dynasty. Copy of an ancient T’ao-t’ieh Sacrificial Vessel 2' },
        { id: 46, title: '宋紫定窑仿古蝉文鼎 3', subtitle: 'Purple Ting Yao of the Sung dynasty.Copy of an ancient Sacrificial Vessel engraved with cicada designs 3' }
      ]
    },
    {
      rowId: 22,
      items: [
        { id: 47, title: '宋龙泉窑六角方瓶缾 26', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Lobed Vase of hexagonal form 26' },
        { id: 48, title: '宋定窑䨥耳雷文小定缾 28', subtitle: 'TING YAO of the Sung dynasty. Small Vase with two handles and bands of scrolled design.28.' },
        { id: 49, title: '宋龙泉窑一枝小缾 27', subtitle: 'LuNG-cH\'üAN YAo of the Sung dynasty.Small Vase for a single flower. 27' },
        { id: 50, title: '宋龙泉窑蕉叶缾 29', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Vase in the form of palm-leaves 29' },
        { id: 51, title: '明宣窑青花竹节小缾 30', subtitle: 'Hsüan Yao of the Ming dynasty — Blue-and-white Vase shaped like bamboo segment 30' },
        { id: 52, title: '宋均窑插花一只小缾 31', subtitle: 'Chün Yao of the Sung dynasty — Miniature Vase for one flower with engraved decor 31' },
        { id: 53, title: '宋紫定窑小蓍艸缾 24', subtitle: 'Purple Ting Yao of the Sung dynasty — Small quadrangular Vase to hold divining-rods 24' },
        { id: 54, title: '元朝枢府窑暗花蒜蒲小缾 21', subtitle: 'Shu Fu Yao of the Yuan dynasty — Small Vase with garlic mouth and underglaze ornament 21' }
      ]
    },
    {
      rowId: 23,
      items: [
        { id: 55, title: '宋官窑高峰砚山 15', subtitle: 'Kuan Yao of the Sung dynasty — Brush Rest in the form of hills with a tall peak 15' },
        { id: 56, title: '宋哥窑五峰砚山 11', subtitle: 'Ko Yao of the Sung dynasty — Brush Rest shaped as mountain with five peaks 11' },
        { id: 57, title: '宋官窑太平有象砚 8', subtitle: 'Kuan Yao of the Sung dynasty — Ink Palette with augury of great peace 8' },
        { id: 58, title: '明宣窑青花龙纹小砚 9', subtitle: 'Hsüan Yao of the Ming dynasty — Ink Palette painted in blue with dragons 9' }
      ]
    },
    {
      rowId: 24,
      items: [
        { id: 59, title: '宋均窑鲛灯 78', subtitle: 'CHün YAo of the Sung dynasty.Dragon Oil Lamp. 78' },
        { id: 60, title: '宋龙泉窑乙花鸡足灯 79', subtitle: 'LuNG-cH\'üAx YAo of the Sung dynasty.OilLamp with a branched pedestalsupported bya clawed foot. 79' },
        { id: 61, title: '明正德窑有柄凤龟灯 80', subtitle: 'CHENG-TÉ Yao of the Ming dynasty.Saucer-shaped Lamp with projecting handle supported byphoenix and tortoise. 80' },
        { id: 62, title: '明成窑五彩莲花灯 81', subtitle: 'CH\'ÊNG YAo of the Ming dynasty. OilLamp in the form of a Nelumbium lotusdecorated in enamel colours. 81' },
        { id: 63, title: '宋定窑凤莲灯 82', subtitle: 'TiNG Yao of the Sung dynasty.PricketCandlestick with phoenix and lotus blossom details. 82' },
        { id: 64, title: '明宣窑青花四台灯 83', subtitle: 'HsüAN YAo of the Ming dynasty. OilLamp with four nozzles painted in blue with white ground. 83' }
      ]
    },
    {
      rowId: 25,
      items: [
        { id: 65, title: '宋龙泉窑牺尊 32', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Wine Jar shaped like a hornless rhinoceros 32' },
        { id: 66, title: '宋定窑象尊 33', subtitle: 'Ting Yao of the Sung dynasty — Wine Jar in the form of an elephant 33' },
        { id: 67, title: '宋汝窑鳬尊 34', subtitle: 'Ju Yao of the Sung dynasty — Wine Ewer shaped like a duck 34' },
        { id: 68, title: '宋墨定鳬尊 35', subtitle: 'Black Ting Yao of the Sung dynasty — Duck-headed Wine Vase 35' },
        { id: 69, title: '宋龙泉窑匏尊 36', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Wine Jar in the shape of a gourd 36' },
        { id: 70, title: '宋钧窑双凤小尊 20', subtitle: 'Chün Yao of the Sung dynasty — Small Jar with two phoenix handles 20' },
        { id: 71, title: '明宣窑青花象尊 39', subtitle: 'Hsuan Yao of the Ming dynasty — Elephant Jar painted in blue 39' },
        { id: 72, title: '宋紫定窑蟠虬尊 51', subtitle: 'Purple Tinc YAo of the Sung dynasty. Sacri-ficial Wine Vessel with grotesque dragon scrolls. 51' }
      ]
    },
    {
      rowId: 26,
      items: [
        { id: 73, title: '明宣窑积红凤首壶 40', subtitle: 'HsüAN YAo of the Ming dynasty. Deep red Wine Pot with phoenix-headed spout 40' },
        { id: 74, title: '宋均窑扁蒲壶 41', subtitle: 'Chün Yao of the Sung dynasty — Flattened Wine Pot with floral scrolls 41' },
        { id: 75, title: '明宣窑青花鹅壶 37', subtitle: 'Hsüan Yao of the Ming dynasty — Wine Jar in the shape of a goose in blue painting 37' },
        { id: 76, title: '明成窑五彩甜瓜壶 38', subtitle: 'Cheng Yao of the Ming dynasty — Melon-shaped Wine Pot decorated with colored glazes 38' },
        { id: 77, title: '宋龙泉窑蒜囊温壶 23', subtitle: 'Lung-ch‘üan Yao of the Sung dynasty — Hot-water Bottle with swelling garlic-shaped mouth 23' },
        { id: 78, title: '宋紫定窑蟠虬壶 18', subtitle: 'Purple Ting Yao of the Sung dynasty — Sacrificial Jar with horned dragons 18' },
        { id: 79, title: '明宣窑积红卤壶 43', subtitle: 'HsüAN YAo of the Ming dynasty. RougePot overspread with deep red ground. 42' },
        { id: 80, title: '明宜兴窑变龔春茶壶 44', subtitle: 'YiHsiNG Yao of the Ming dynasty. Tea Pot of Kung-ch\'un\'s make with\'transmutationpale brown body. 44' },
        { id: 81, title: '明宜兴窑变龔春茶壶 45', subtitle: 'YiHsiNG Yao of the Ming dynasty. Tea Pot of Kung-ch\'un\'s make with\'transmutationpale brown body. 45' },
        { id: 82, title: '明弘治窑娇黄葫芦壶 42', subtitle: 'HuNG-cHiH YAo of the Ming dynasty. Gourd. shaped Wine Pot with pale yellow ground. 42' }
      ]
    }
  ];
  return (
    <div className="relative" style={{ overflowX: 'hidden' }}>
      {/* 第一部分 */}
      <div className="relative">
        <img src={img_1} alt="Hero background" className="w-full h-auto" />
        <div className="left-[6vw]  bottom-[4.5vw] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffffc6] text-[0.7vw] leading-[1.2vw] text-justify">探微篇，运用独创的瓷器独特性量化模型对项元汴收藏的83件瓷器进行独特性量化分析，从形状、釉色、纹饰、器型和历史五个维度解析瓷器的独特基因，将瓷器的独特性可视化呈现，将主观性评价例如“奇特”“稀世珍品”“罕见”转化为可验证的量化模型，为艺术史研究提供科学性跨学科方法论。</span>
            <span className="text-[#ffffffc6] text-[0.7vw] leading-[1.2vw] text-justify">In the chapter of Microcosmology, the original quantitative model of porcelain uniqueness is used to quantitatively analyse the uniqueness of 83 pieces of porcelain in Xiang Yuanbian's collection, and to analyse the unique genes of porcelain from five dimensions: shape, glaze, decoration, type and history, so as to visualise the uniqueness of porcelain, and to transform the subjective evaluations, such as ‘peculiar’and ‘rare’, into verifiable quantitative models, providing a scientific and interdisciplinary methodology for art history research. </span>
          </div>
        </div>
      </div>
      {/* 第二部分 */}
      <div className="relative">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <div className="left-[25%] top-[8%] absolute w-[50%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[2vw] text-center" style={{ letterSpacing: '0.1em' }}>瓷器独特性量化分析</span>
            <span className="text-[#ffffff] text-[1.5vw] leading-[2vw] text-center" style={{ letterSpacing: '0.1vw' }}>Quantitative Analysis of Porcelain Uniqueness</span>
          </div>
        </div>
        <div className="left-[20%]  top-[20%] absolute w-[60%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center">「器外有魂:轮廓中的独特性密码」</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center">我们将83件瓷器按照器型分类，提取了83件瓷器的轮廓外形，并且在网站中可以点击每一件瓷器的轮廓困查看它的放大图、详细内容和粒子动画效果。我们从83件瓷器的轮廓外形发现其与常规瓷器的不同和独特性。</span>
          </div>
        </div>
        <div className="left-[20%]  top-[30%] absolute w-[60%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center">"Soul Beyond the Form: Decoding Uniqueness in Contours"</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center">We have classified the 83 porcelain pieces by vessel type and extracted their contour outlines. On the website, you can click on each contour outline to view an enlarged image, detailed content, and particle animation effects. By analyzing the silhouette shapes of these 83 pieces, we identified their distinctiveness compared to conventional porcelain forms, revealing hidden patterns and unique characteristics within their outlines.</span>
          </div>
        </div>
        <div className="left-[15%]  bottom-[8%] absolute w-[70%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] leading-[1.3vw] text-center">探微篇，运用独创的瓷器独特性量化模型对项元汴收藏的83件瓷器进行独特性量化分析，从形状、釉色、纹饰、器型和历史五个维度解析瓷器的独特基因,“罕见”转化为可验证的量化模型，为艺术史研究提供科学性跨学科方法论。将瓷器的独特性可视化呈现，将主观性评价例如“奇特”“稀世珍品”</span>
            <span className="text-[#ffffff] text-[0.8vw] leading-[1.3vw] text-center">Exploring the Subtle: Quantifying the Uniqueness of 83 Porcelain Pieces from Xiang Yuanbian’s Collection This section employs an innovative quantitative model for porcelain uniqueness to analyze the 83 porcelain items in Xiang Yuanbian’s collection. The analysis deciphers their "unique genetic traits" across five dimensions: shape, glaze color, decoration, vessel type, and historical context. By converting subjective terms like "rare" into a verifiable quantitative framework, this approach offers a scientific, interdisciplinary methodology for art historical research. The uniqueness of each piece is visualized through data, transforming qualitative assessments such as "unusual" or "rare masterpiece" into measurable, objective insights.</span>
          </div>
        </div>
        <div className="left-[7%] bottom-[30%] absolute w-[86%] h-[30%] flex flex-row items-center">
          <div className='w-[33.3%] h-auto'>
            <video
              src={video_20}
              className="w-full h-auto mix-blend-screen"  // 铺满容器宽度，高度自适应
              style={{
                backgroundColor: 'transparent',
                isolation: 'isolate',
                pointerEvents: 'none'
              }}
              autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
              loop                      // 循环播放
              muted                     // 静音（避免自动播放被浏览器阻止）
              playsInline               // iOS 设备内联播放（非全屏）
              controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
            />
          </div>
          <div className='w-[33.3%] h-auto'>
            <video
              src={video_65}
              className="w-full h-auto mix-blend-screen"  // 铺满容器宽度，高度自适应
              style={{
                backgroundColor: 'transparent',
                isolation: 'isolate',
                pointerEvents: 'none'
              }}
              autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
              loop                      // 循环播放
              muted                     // 静音（避免自动播放被浏览器阻止）
              playsInline               // iOS 设备内联播放（非全屏）
              controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
            />
          </div>
          <div className='w-[33.3%] h-auto'>
            <video
              src={video_11}
              className="w-full h-auto mix-blend-screen"  // 铺满容器宽度，高度自适应
              style={{
                backgroundColor: 'transparent',
                isolation: 'isolate',
                pointerEvents: 'none'
              }}
              autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
              loop                      // 循环播放
              muted                     // 静音（避免自动播放被浏览器阻止）
              playsInline               // iOS 设备内联播放（非全屏）
              controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
            />
          </div>
        </div>
      </div>
      {/* 第三部分 */}
      <div className="relative interactive-base" ref={parentRef}>
        <img src={img_3} alt="Hero background" className="w-full h-auto" />
        <div className="right-[8%] top-[2%] absolute w-[25%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[2.3vw] text-right" style={{ letterSpacing: '0.1em' }}>根据瓷器器型分类</span>
            <span className="text-[#ffffff] text-[1.5vw] leading-[2vw] text-right" style={{ letterSpacing: '0.1vw' }}>Classification According to </span>
            <span className="text-[#ffffff] text-[1.5vw] leading-[2vw] text-right" style={{ letterSpacing: '0.1vw' }}>Porcelain Ware Type</span>
          </div>
        </div>
        <div className="right-[8%] top-[6%] absolute w-[28%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] text-right leading-[1.5vw]">当83件瓷器的剪影在屏幕上次第展开，您将亲历一场跨越时空的形态巡礼——点击任意外形轮廓，放大镜将揭示精妙的粒子动画：宋代官窑佛指甲杯的裂釉纹如冰河初绽，明宣德青花鹅壶的曲颈线似天鹅引吭。这些被项元汴珍视的器物，其轮廓曲线与同时代民窑量产瓷器形成惊人对比：前者曲率变化标准差达0.87（后者仅0.32），器型高宽比离群值超常规范围2.4倍。</span>
            <span className="text-[#ffffff] text-[1vw] mt-[2vw] text-right leading-[1.5vw]">As the Silhouettes of 83 Porcelain Pieces Unfold on Screen. You will embark on a timeless morphological journey—clicking on any silhouette reveals a magnifying lens unveiling intricate particle animations: The cracked glaze patterns of a Northern Song imperial kiln Buddha’s Nail Cup resemble the first fissures of an ice-river, while the graceful neck curve of a Ming Xuande blue-and-white Goose Vase mirrors a swan raising its neck in song. These treasured objects, valued by Xiang Yuanbian, starkly contrast with mass-produced wares from contemporary folk kilns: their curvature variation standard deviation reaches 0.87 (compared to 0.32 for folk kiln wares), and their aspect ratio outliers exceed the conventional range by 2.4 times.</span>
          </div>
        </div>
        
        {/* 居中区域 */}
        <div className='h-[25%] w-[100%] top-[23%] absolute' ref={sectionRef}>
          {/* <img
            src={img_3_1}
            className={`w-[90%] h-auto absolute opacity-50
              ${isInView ? 'slide-in-from-top-left left-[-35%] top-[-25%]' : 'left-[-100%] top-[-50%]'}`}
          /> */}
           <img
            src={img_3_1}
            className={`w-[45%] h-auto absolute opacity-50
              ${isInView ? 'slide-in-from-top-left left-[-25%] top-[-70%]' : 'left-[-100%] top-[-50%]'}`}
          />
          <img
            src={img_3_2}
            className={`w-[55%] h-auto  absolute
              ${isInView ? 'slide-in-from-bottom-right right-[-45%] top-[40%]' : 'right-[-100%] top-[50%]'}`}
          />
          <div className=' wind-sway w-[60%] h-auto absolute top-[-15%] right-[-2%] opacity-70'>
            <img src={img_3_3} className={`w-[100%] h-auto absolute top-[15%]
            ${isInView ? 'slide-in-from-right right-[-12%]' : 'right-[-100%] '}`} />
          </div>

        </div>
        <div className="right-[8%] bottom-[38%] absolute w-[18%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] text-right">
              正是这些挣脱范式束缚的线条，让我们追问：如何用数据丈量器物的独特性基因？ 在接下来的量化探索中，您将见证五维分析模型如何将曲线张力、釉色幻变与历史沉淀，转化为可触可感的科学叙事。此刻，请触摸这些轮廓——它们既是进入量化世界的钥匙，也是文明基因的视觉宣言。</span>
            <span className="text-[#ffffff] text-[1vw] text-right mt-[1.2vw]">
              It is these lines that break free from paradigms that lead us to ask: how can we use data to measure the genes of uniqueness in artefacts? In the quantitative exploration that follows, you will witness how a five-dimensional analytical model transforms curvilinear tensions, glaze variations, and historical deposits into a palpable scientific narrative. For the moment, touch these contours - they are both the key to the world of quantification and a visual declaration of the genes of civilisation.</span>
          </div>
        </div>
        <div className="right-[20%] bottom-[28%] absolute w-[60%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[2vw] text-center" style={{ letterSpacing: '0.1em' }}>独特性量化分析与标准分数算取</span>
            <span className="text-[#ffffff] text-[1.6vw] leading-[2vw] text-center">Quantitative Analysis of Uniqueness and Standard Score Computation</span>
          </div>
        </div>
        <div className="right-[10%] bottom-[24%] absolute w-[80%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] text-center">探微篇的核心是首创的“瓷器独特性量化模型”，旨在通过多维度参数化分析，科学量化其区别于普通瓷器的独特性价值。</span>
            <span className="text-[#ffffff] text-[1vw] text-center">模型从形状造型、纹饰设计、釉色表现、工艺技术及历史背景五大维度切入，构建了一套客观评价体系。</span>
            <span className="text-[#ffffff] text-[1vw] text-center mt-[0.6vw]">The core of the micro-exploration chapter is the first ‘porcelain uniqueness quantification model’, which aims to scientifically quantify the uniqueness value of porcelain different from ordinary porcelain through multi-dimensional parametric analysis. </span>
            <span className="text-[#ffffff] text-[1vw] text-center ">The model is based on five dimensions: shape, decoration, glaze, technology and historical background, and builds a set of objective evaluation system.</span>
          </div>
        </div>
        {/* 交互区 */}
        <div className='absolute top-[2%] left-[8%] h-[62%] w-[60%] flex flex-row'>
          <span className='absolute top-[-2%] left-[2.5%] text-[1.2vw]'style={{ letterSpacing: '0.1em' }}>点击查看 Click to view</span>
          {/* 左侧标题列表 */}
          <div className='w-[8%] h-full min-h-[30px]'>
            {interactiveTitles.map((title, index) => (
              <span
                key={`title-${index}`}
                className='interactive-title'
              >
                {title}
              </span>
            ))}
          </div>
          {/* 右侧交互项区域 */}
          <div className='w-[92%] h-full min-h-[30px] box-border'>
            {interactiveItems.map((row) => (
              <div key={row.rowId} className='w-full h-[4%] flex flex-row'>
                {row.items.map((item) => (
                  <Popover
                    key={item.id}
                    trigger="click"
                    placement="topRight"
                    color='#ffffff2d'
                    classNames={{ root: 'custom-popover' }}
                    content={
                      <div className="flex flex-col">
                        <span className="popover-main">{item.title}</span>
                        <span className="popover-sub">{item.subtitle}</span>
                      </div>
                    }
                  >
                    <div
                      className={`interactive-body ${selectedInteractiveId === item.id ? 'interactive-active' : ''
                        } ${item.widthClass || 'w-[12%]'}`} // 应用宽度类
                      onClick={(e) => handleInteractiveClick(item.id, e.currentTarget)}
                    >
                      <img src={new URL(`../assets/images/scale83/${item.id}.webp`, import.meta.url).href} className="scale-83-img" />
                    </div>
                  </Popover>
                  
                ))}
              </div>
            ))}
          </div>

        </div>
        {/* 视频播放区域 */}
        {isPlayVideo && (
          <div className='absolute left-[0%] w-[100%] h-auto'
            style={{
              top: `${videoID > 82 ? videoTop : videoTop - 8}%`,
              pointerEvents: 'none'
            }}>
            <video
              src={new URL(`../assets/videos/scale83/${videoID}.mp4`, import.meta.url).href}
              className="w-full h-auto mix-blend-screen"  // 铺满容器宽度，高度自适应
              style={{
                backgroundColor: 'transparent',
                isolation: 'isolate',
                pointerEvents: 'none'
              }}
              autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
              loop                      // 循环播放
              muted                     // 静音（避免自动播放被浏览器阻止）
              playsInline               // iOS 设备内联播放（非全屏）
              controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
            />
          </div>
        )}
        <div className="absolute bottom-[2%] left-[0%] w-[100%] h-auto" ref={parentRef1}>
          <img src={img_2} alt="Hero background" className="w-full h-auto" />
          <img src={img_3_2} className={`w-[60%] absolute left-[-39%] bottom-[25%] rotate-[40deg] ${isParentInView1 ? 'slide-in-left' : 'left-[-100%]'}`} />
          <img src={img_3_2} className={`w-[60%] absolute right-[-35%] bottom-[-20%] rotate-[70deg]  ${isParentInView1 ? 'slide-in-right' : 'right-[-100%]'}`} />
          <img src={img_6} className='top-[-2%] w-[25%] left-[15%] h-auto absolute' />
          <img src={img_7} className='top-[-2%] w-[40%] right-[12%] h-auto absolute' />
          <img src={img_8} className='bottom-[8%] w-[76%] left-[12%] h-auto absolute' />

          <div className="left-[15%]  top-[30%] absolute w-[25%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[1.5vw] text-center">常见的基本通用瓷器（形状） </span>
            </div>
          </div>
          <div className="right-[12%]  top-[30%] absolute w-[40%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[1.5vw] text-center">《历代名瓷图谱》中的瓷器（部分）</span>
            </div>
          </div>
          <div className="left-[12%] bottom-[3%] absolute w-[76%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[01.5vw] text-center">从多维度量化：瓷器独特性量化核心维度选取与数据来源</span>
            </div>
          </div>
        </div>
      </div>
      {/* 第四部分 */}
      {/* <div className="relative" ref={parentRef1}>
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <img src={img_3_2} className={`w-[60%] absolute left-[-39%] bottom-[25%] rotate-[40deg] ${isParentInView1 ? 'slide-in-left' : 'left-[-100%]'}`} />
        <img src={img_3_2} className={`w-[60%] absolute right-[-35%] bottom-[-20%] rotate-[70deg]  ${isParentInView1 ? 'slide-in-right' : 'right-[-100%]'}`} />
        <img src={img_6} className='top-[2%] w-[25%] left-[15%] h-auto absolute' />
        <img src={img_7} className='top-[2%] w-[40%] right-[12%] h-auto absolute' />
        <img src={img_8} className='bottom-[8%] w-[76%] left-[12%] h-auto absolute' />

        <div className="left-[15%]  top-[32%] absolute w-[25%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.5vw] text-center">常见的基本通用瓷器（形状） </span>
          </div>
        </div>
        <div className="right-[12%]  top-[32%] absolute w-[40%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.5vw] text-center">《历代名瓷图谱》中的瓷器（部分）</span>
          </div>
        </div>
        <div className="left-[12%] bottom-[5%] absolute w-[76%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[01.5vw] text-center">从多维度量化：瓷器独特性量化核心维度选取与数据来源</span>
          </div>
        </div>
      </div> */}
      {/* 第五部分 */}
      <div className="relative" ref={img32ParentRef}>
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <img src={img_3_2} className={`w-[75%] absolute left-[-35%] bottom-[-75%] z-[5] ${isImg32InView ? 'rotate-on-visible' : ''}`} />
        <div className="left-[25%] top-[3vw] absolute w-[50%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center" style={{ letterSpacing: '0.1em' }}>瓷器独特性量化模型</span>
            <span className="text-[#ffffff] text-[1.5vw] leading-[2vw] text-center" style={{ letterSpacing: '0.1em' }}>A Quantitative Model of Porcelain Uniqueness</span>
          </div>
        </div>
        <div className="left-[15%]  top-[20%] absolute w-[75%] z-[9]">
          <div className="flex flex-col items-left">
            <span className="text-[1.5vw] text-left" style={{ letterSpacing: '0.1em' }}>量化模型说明 <span className="text-[1.3vw] text-left" style={{ letterSpacing: '0.1em' }}>Quantitative model description</span></span>
            <span className="uniqueness-text mt-[1.5vw]">1.核心维度与权重(熵权法分配)：Core dimensions and weights (assigned by entropy weighting method): </span>
            <span className="uniqueness-text">·形状造型(38%): 通过高宽比、曲率积分和对称性偏差等几何参数，精准捕捉器物的轮廓创新性。 </span>
            <span className="uniqueness-text">Shape modelling (38%): Accurately captures the innovative contour of the object through geometric parameters such as aspect ratio, curvature integral and symmetry deviation. </span>
            <span className="uniqueness-text">·纹饰(22%): 结合纹样复杂度与历史首创性双重评分。</span>
            <span className="uniqueness-text">Decoration (22%): a combination of complexity and historical originality.</span>
            <span className="uniqueness-text">·釉色(25%): 参照釉色分类数据库进行稀有度赋值。</span>
            <span className="uniqueness-text">Glaze Colour (25%): Rarity is assigned with reference to the Glaze Colour Classification Database.</span>
            <span className="uniqueness-text">·工艺技术(12%): 聚焦胎体处理与特殊技法。</span>
            <span className="uniqueness-text">Technique (12%): Focus on carcass treatment and special techniques. </span>
            <span className="uniqueness-text">·历史背景(3%): 量化项元汴评注频次与文献记载强度。</span>
            <span className="uniqueness-text">Historical background (3%): quantify the frequency of commentaries and intensity of documentation.</span>
            <span className="uniqueness-text mt-[1.5vw]">2.标准化方法: Z-score标准化(消除量纲差异) </span>
            <span className="uniqueness-text">Standardisation method: Z-score standardisation (eliminating differences in scale)</span>
            <span className="uniqueness-text mt-[1.5vw]">3.综合得分公式: 综合得分=∑(权重x标准化参数值) </span>
            <span className="uniqueness-text">Combined score formula: Combined score = ∑(weight x standardised parameter value)</span>
          </div>
        </div>
      </div>
      {/* 第六部分 */}
      <div className="relative">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <div className="left-[5%] bottom-[13%] absolute w-[40%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-left" style={{ letterSpacing: '0.1em' }}>五个维度标准化分数雷达图</span>
            <span className="text-[#ffffff] text-[1.3vw] leading-[2vw] text-left" style={{ letterSpacing: '0.1em' }}>Five-Dimensional Standardized Score Radar Chart</span>
          </div>
        </div>
        <div className="left-[5%]  bottom-[28%] absolute w-[32%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.9vw] leading-[1.5vw] text-justify">这是83件瓷器独特性量化的五个维度标准化分数雷达图：您可点击查看任意一件瓷器的五个维度独特性分数分布图，也可以点击两个或多个瓷器进行对比分析。</span>
            <span className="text-[#ffffff] text-[0.9vw] leading-[1.5vw] text-justify">This is a radar chart of the five dimensions of standardised scores for the quantification of uniqueness for the 83 porcelains: you can click to see the distribution of the five dimensions of uniqueness scores for any of the porcelains, or you can click on two or more porcelains for a comparative analysis.</span>
          </div>
        </div>
        <div className="right-[5%] top-[10%] absolute w-[62%] h-[80%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23690861/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
      </div>
      {/* 第七部分 */}
      <div className="relative ">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <div className="left-[30%] top-[5%] absolute w-[40%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center" style={{ letterSpacing: '0.1em' }}>综合标准化分数折线图</span>
            <span className="text-[#ffffff] text-[1.6vw] leading-[2vw] text-center">Combined Standardised Score Line Chart</span>
          </div>
        </div>
        <div className="left-[10%] bottom-[5%] absolute w-[80%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center">这是综合得分折线图：左边是按照综合得分从高到低将83件瓷器独特性得分进行排列，用户可以滑动查看任意一个分值对应的瓷器名称和具体分数，也可以直观地看出高独特性得分前几名和低独特性得分后几名。右边是按照瓷器编号依次从左到右排列的独特性综合得分折线图，横轴为瓷器编号，纵轴为标准化分数，圆点的颜色根据综合得分的高低进行深浅变化，波动曲线揭示项氏收藏的“偏好峰值”，如宣德、成化官窑集中于高分段。</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center">
              This is the comprehensive score line graph: on the left is in accordance with the composite score from high to low will be 83 pieces of porcelain uniqueness score, the user can slide to see any one of the score corresponding to the name of the porcelain and the specific score, but also intuitively see the high uniqueness score of the first few and low uniqueness scores of the last few. On the right is in accordance with the porcelain number sequentially arranged from left to right of the uniqueness of the integrated score line graph, the horizontal axis for the porcelain number, the vertical axis for the standardised score, the colour of the dots according to the integrated score of the high level of shades, fluctuations in the curve reveals the Xiang's collection of the ‘peak of preference’, such as Xuande, Chenghua kilns concentrated in the high score section.</span>
          </div>
        </div>
        <div className="left-[5%] top-[18%] absolute w-[45%] h-[55%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23690924/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
        <div className="right-[5%] top-[18%] absolute w-[45%] h-[60%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23690957/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>

      </div>
      {/* 第八部分 */}
      <div className="relative" ref={parentRef3}>
        <img src={img_5} alt="Hero background" className="w-full h-auto" />
        <div className="left-[5%] top-[5%] absolute w-[40%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-left" style={{ letterSpacing: '0.1em' }}>高独特性瓷器-前10名</span>
            <span className="text-[#ffffff] text-[1.6vw] leading-[2vw] text-left" style={{ letterSpacing: '0.1em' }}>Top 10 Porcelains with High Uniqueness</span>
          </div>
        </div>
        <div className="left-[5%] top-[12%] absolute w-[18%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] text-justify">这里展示的是瓷器独特性综合得分前十名列表：动态排序展示独特性前 10 名瓷器，点击可查看瓷器的详情介绍，构建“数据化文物排行榜”。</span>
            <span className="text-[#ffffff] text-[1vw] mt-[2vw] text-justify">Here is a list of the top ten porcelain uniqueness scores: dynamically sorted display of the top 10 porcelain uniqueness, click to view the details of the porcelain, to build a ‘data-based cultural relics ranking’.</span>
          </div>
        </div>
        <img src={img_4_10}
          className={`top-[6%] w-[55%] right-[-13%] h-auto absolute ${isParentInView3 ? 'slide-in-right' : 'right-[-100%]'}`} />
        <img src={img_4_8}
          className={`top-[42%] w-[30%] right-[-2%] h-auto absolute ${isParentInView3 ? 'slide-in-right' : 'right-[-100%]'}`} />
        <img src={img_4_11}
          className={`top-[28%] w-[58%] right-[0%] h-auto absolute duration-3000 ${isParentInView3 ? 'opacity-100' : 'opacity-0'}`} />
        <img src={img_4_13}
          className={`top-[69%] w-[83%] right-[0%] h-auto absolute ${isParentInView3 ? 'slide-in-right' : 'right-[-100%]'}`} />
        {selectedItem && (
          <OPPop
            appId={1}
            popId={selectedItem.id}
            onClose={() => setSelectedItem(null)}
          />
        )}
        <div className="left-[37%] top-[5%] absolute w-[43%] h-[16%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 64 })}>
          <img src={spc_1} className="absolute w-[100%] h-auto left-[0%] top-[-5%]" />
        </div>
        <div className="left-[51%] top-[21%] absolute w-[18%] h-[14%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 60 })}>
          <img src={spc_10} className="absolute w-[100%] h-auto left-[5%] top-[-5%]" />
        </div>
        <div className="right-[5%] top-[21%] absolute w-[25.5%] h-[14%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 59 })}>
          <img src={spc_11} className="absolute w-[100%] h-auto left-[0%] top-[-53%]" />
        </div>
        <div className="right-[2%] top-[43%] absolute w-[23%] h-[24%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 54 })}>
          <img src={spc_4} className="absolute w-[100%] h-auto left-[-10%] top-[12%] scale-[130%]" />
        </div>
        <div className="left-[38%] top-[35%] absolute w-[35%] h-[27%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 38 })}>
          <img src={spc_3} className="absolute w-[100%] h-auto left-[2%] top-[-20%]" />
        </div>
        <div className="left-[10%] top-[45%] absolute w-[28%] h-[19%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 3 })}>
          <img src={spc_5} className="absolute w-[100%] h-auto left-[2%] top-[-33%]" />
        </div>
        <div className="left-[36%] top-[59%] absolute w-[20%] h-[14%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 30 })}>
          <img src={spc_6} className="absolute w-[90%] h-auto left-[-2%] top-[3%]" />
        </div>
        <div className="left-[10%] top-[72%] absolute w-[26%] h-[10%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 63 })}>
          <img src={spc_9} className="absolute w-[100%] h-auto left-[-12%] top-[-5%] scale-[130%]" />
        </div>
        <div className="left-[37%] top-[75%] absolute w-[20%] h-[19%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 48 })}>
          <img src={spc_8} className="absolute w-[100%] h-auto left-[0%] top-[-40%]" />
        </div>
        <div className="right-[13%] top-[66%] absolute w-[30%] h-[24%] hover:scale-[1.05] duration-300 cursor-pointer" onClick={() => setSelectedItem({ id: 37 })}>
          <img src={spc_7} className="absolute w-[100%] h-auto left-[0%] top-[6%] scale-[130%]" />
        </div>
      </div>
      {/* 第九部分 */}
      <div className="relative">
        <video
          src={video_5}
          className="w-full h-auto"  // 铺满容器宽度，高度自适应
          autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
          loop                      // 循环播放
          muted                     // 静音（避免自动播放被浏览器阻止）
          playsInline               // iOS 设备内联播放（非全屏）
          controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
        />
        <div className="left-[31%] bottom-[8%] absolute w-[38%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] text-center" style={{ letterSpacing: '0.1em' }}>您可以查看高独特性前三名瓷器的三维还原模型360度旋转动画。</span>
            <span className="text-[#ffffff] text-[1vw] text-center" style={{ letterSpacing: '0.1em' }}>You can view a 360-degree rotating animation of the 3D restored models of the top three porcelain pieces with high uniqueness.</span>
          </div>
        </div>
      </div>
      {/* 第十部分 */}
      <div className="relative">
        <video
          src={video_8}
          className="w-full h-auto"  // 铺满容器宽度，高度自适应
          autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
          loop                      // 循环播放
          muted                     // 静音（避免自动播放被浏览器阻止）
          playsInline               // iOS 设备内联播放（非全屏）
          controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
        />
        <div className="left-[31%] bottom-[8%] absolute w-[38%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] text-center" style={{ letterSpacing: '0.1em' }}>您可以查看高独特性前三名瓷器的三维还原模型360度旋转动画。</span>
            <span className="text-[#ffffff] text-[1vw] text-center" style={{ letterSpacing: '0.1em' }}>You can view a 360-degree rotating animation of the 3D restored models of the top three porcelain pieces with high uniqueness.</span>
          </div>
        </div>
      </div>
    </div>

  )
}